import React, { useEffect } from 'react';
import { Outlet, useParams, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import socket from '../../utils/socket';
import { PermissionsProvider } from '../../context/PermissionsContext';

const WorkspaceLayout = () => {
  const { workspaceUuid } = useParams();
  const location = useLocation();
  const [collapsed, setCollapsed] = React.useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const isChatPage = location.pathname.includes('/chats');
  const workspaceName = localStorage.getItem('workspaceName') || 'Workspace';

  // Close the mobile drawer whenever the route changes (i.e. a nav item was tapped).
  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  // Announce presence for this workspace as soon as the layout mounts, and
  // re-announce on socket reconnects so the server's in-memory map is correct.
  useEffect(() => {
    if (!workspaceUuid) return;
    const announce = () => {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const role = localStorage.getItem('userRole') || 'Member';
      socket.emit('joinWorkspace', {
        workspaceUuid,
        userId: user._id || user.id || user.email || user.name || 'anon',
        name: user.name || user.email || 'User',
        role
      });
    };
    announce();
    socket.on('connect', announce);
    return () => { socket.off('connect', announce); };
  }, [workspaceUuid]);

  return (
    <PermissionsProvider>
    <div className="workspace-layout">
      {/* Mobile-only top bar with hamburger (hidden on desktop via CSS) */}
      <div className="mobile-topbar">
        <button className="mobile-ham" onClick={() => setMobileOpen(true)} aria-label="Open menu">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></svg>
        </button>
        <div className="mobile-topbar-brand">
          <img src="/vetobase-icon.png" alt="Vetobase" className="mobile-topbar-logo" />
          <div className="mobile-topbar-txt">
            <span className="mobile-topbar-name">Vetobase</span>
            <span className="mobile-topbar-ws">{workspaceName}</span>
          </div>
        </div>
      </div>

      {/* Overlay behind the drawer (mobile) */}
      <div
        className={`sidebar-overlay ${mobileOpen ? 'show' : ''}`}
        onClick={() => setMobileOpen(false)}
      />

      <Sidebar
        workspaceUuid={workspaceUuid}
        collapsed={collapsed}
        onToggle={() => setCollapsed(!collapsed)}
        mobileOpen={mobileOpen}
      />
      <main className={`workspace-main ${isChatPage ? 'no-padding full-height' : ''} ${collapsed ? 'collapsed' : ''}`}>
        <Outlet />
      </main>
    </div>
    </PermissionsProvider>
  );
};

export default WorkspaceLayout;
